module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-378.a040284.woff2";